import { useSyncExternalStore } from 'react';

const MEDIA_QUERY = '(hover: hover) and (pointer: fine)';

function subscribe(onStoreChange: () => void): () => void {
  const mq = window.matchMedia(MEDIA_QUERY);
  mq.addEventListener('change', onStoreChange);
  return () => mq.removeEventListener('change', onStoreChange);
}

function getSnapshot(): boolean {
  return window.matchMedia(MEDIA_QUERY).matches;
}

function getServerSnapshot(): boolean {
  return false;
}

/**
 * Subscribes to a hover-capable, fine-pointer media query as reactive state.
 *
 * @returns `true` when the device has a hover-capable fine pointer (e.g. mouse); always `false` during SSR and hydration
 */
export function useHasHover(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
